/**
 * @module attribute reports
 */
import { createReducer } from '@reduxjs/toolkit';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeAttributeResponses = (state, action) => {
  const attributeResponses = action?.payload?.entities?.attributeResponses || {};

  Object.values(attributeResponses).forEach((attributeResponse) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[attributeResponse.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[attributeResponse.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...attributeResponse,
    };
  });
};

const attributeResponses = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(reportingActions.fetchQuestionAttributeResponses.fulfilled, mergeAttributeResponses);
});

export default attributeResponses;
